import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Seleziona posizione',
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'In loco',
      [RoomServiceLocationType.TableService]: 'In loco',
      both: 'In loco',
    },
    [ORDER_METHODS.PICKUP]: 'Ritiro',
    [ORDER_METHODS.DELIVERY]: 'Consegna',
  },
  text_inputs: {
    room_service_details: {
      placeholder: {
        [RoomServiceLocationType.RoomService]: 'Inserisci il numero della stanza',
        [RoomServiceLocationType.TableService]: 'Inserisci il numero del tavolo',
      },
    },
    address: {
      placeholder: 'Cerca il tuo indirizzo',
    },
    street_name: {
      placeholder: 'Via',
    },
    street_number: {
      placeholder: 'Numero civico',
    },
    city: {
      placeholder: 'Città',
    },
    zip: {
      placeholder: 'CAP',
    },
  },
  time_options: {
    asap: {
      title: 'Standard',
      description: 'Pronto in {{time}} min',
    },
    scheduled: {
      title: 'Pianifica per dopo',
    },
  },
  time_drop_down: {
    today: 'Oggi',
  },

  room_service: {
    location: 'Seleziona posizione',
  },

  pickup: {
    address: 'Indirizzo di ritiro',
    when: 'Quando?',
  },

  delivery: {
    where: 'Dove?',
    when: 'Quando?',
    address: 'Il tuo indirizzo',
    delivery_area: 'Il nostro raggio di consegna',
  },

  order: {
    instructions: "Istruzioni per l'ordine",
    placeholder: "Inserisci le istruzioni per l'ordine...",
  },

  buttons: {
    view_menu: 'Vedi il menu',
    see_hours: 'Vedi gli orari',
    next: 'Avanti',
    change: 'Modifica',
    save: 'Salva',
  },

  labels: {
    when: 'Quando?',
    pickup: 'Ritiro online',
    delivery: 'Consegna',
    pickup_time: 'orario di ritiro',
    delivery_time: 'orario di consegna',
    discount: 'Solo qui {{value}} di sconto online',
    pre_orders_enabled: 'Per ora puoi effettuare un ordine programmato per dopo',
    change_location: '← Torna al menu se preferisci una sede diversa',
    return: 'Torna',
  },

  items_dropped: {
    count_one: '{{count}} articolo rimosso',
    count_other: '{{count}} articoli rimossi',
    pickup_reason: '— non disponibile per il ritiro.',
    delivery_reason: '— non disponibile per la consegna.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      "Siamo spiacenti, non abbiamo trovato quell'indirizzo. Riprova inserendo prima la via nel campo di ricerca.",
    [ValidationErrors.address_not_serviceable]:
      'Il tuo indirizzo è fuori dalla nostra zona di consegna. Vuoi cambiare indirizzo o passare al ritiro? 😊',
    [ValidationErrors.no_drivers_available]:
      'Siamo spiacenti, al momento non possiamo consegnare. Vuoi ordinare con ritiro? 😊',

    room_service_unavailable: 'Siamo spiacenti, al momento non offriamo il servizio in loco.',
    pickup_unavailable: 'Siamo spiacenti, al momento non offriamo il ritiro.',
    delivery_unavailable: 'Siamo spiacenti, al momento non offriamo la consegna.',
    delivery_paused: 'Siamo spiacenti, al momento non offriamo la consegna.',
    outside_pickup_times: 'Al momento non offriamo il ritiro. I nostri orari di ritiro:',
    outside_delivery_times: 'Al momento non offriamo la consegna. I nostri orari di consegna:',
    orders_paused_inactivity:
      "A causa dell'elevata domanda non possiamo accettare altri ordini online. Ordina in negozio o riprova tra 30 minuti.",
    orders_paused_manual_end_of_day: 'Siamo spiacenti, siamo chiusi per il resto della giornata.',
    orders_paused_manual_until_time:
      "A causa dell'elevata domanda non possiamo accettare altri ordini online. Ordina in negozio o riprova dalle {{pausedUntil}}",
    company_closed: 'Purtroppo al momento non siamo aperti.',
    pickup_closed:
      'Accettiamo ordini con ritiro fino alle {{time}} poiché il nostro tempo di preparazione è di {{preparationTime}} minuti.',
    delivery_closed:
      'Accettiamo ordini con consegna fino alle {{time}} poiché il nostro tempo di consegna è di {{preparationTime}} minuti.',
    live_orders_off:
      'Siamo spiacenti, al momento non possiamo accettare altri ordini online. Grazie per la comprensione.',
    orders_unavailable:
      '{{type}} non è disponibile al momento. Il prossimo {{typeTime}} disponibile è {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Siamo spiacenti, al momento non abbiamo corrieri disponibili. Riprova più tardi, o ordina con ritiro e usa il codice promo <PromoCode>{{code}}</PromoCode> al pagamento.',
    without_code:
      'Siamo spiacenti, al momento non abbiamo corrieri disponibili. Riprova più tardi, o ordina con ritiro.',
    copied: 'Codice promo copiato',
  },
};
